/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

require('../styles/quizz.scss');
require('../../node_modules/react-image-gallery/styles/scss/image-gallery.scss');

import React from 'react';
import {connect} from 'react-redux';
import ImageGallery from 'react-image-gallery';

import store from '../store';
import actions from '../actions/quizzActions';

import Sharing from './Sharing';

class Quizz extends React.Component {

  componentWillMount () {
    // store.dispatch(actions.QUIZZ_CREATE(this.props.quizzId));
  }

  componentDidMount () {
    this._quizzSlides.slideToIndex(this.props.currentSlide);
  }

  componentWillUpdate () {}

  componentDidUpdate (prevProps) { // accept prevProps and prevState for arguments
    if(this._quizzSlides){
      if(prevProps.currentSlide !== this.props.currentSlide){
        this._quizzSlides.slideToIndex(this.props.currentSlide);
      }
    }
  }

  handleAnswer (event) {
    if(event.currentTarget.className.indexOf('answered') < 0 && event.target.id){
      event.target.className = event.target.className+' selected';
      event.currentTarget.className += ' answered';
      store.dispatch(actions.QUIZZ_SAVE_ANSWER(this.props.quizzId, this.state.currentSlide, event.target.getAttribute('value')));
    }
  }

  handleSlideChange (index) {
    store.dispatch(actions.QUIZZ_UPDATE_CURRENT_SLIDE(index, this.props.quizzId));
    this.setState({
      currentSlide: index
    });
  }

  restartQuizz () {
    store.dispatch(actions.QUIZZ_RESET_ANSWERS(this.props.quizzId));
    this._quizzSlides.slideToIndex(1);
  }

  nextSlide () {
    this._quizzSlides.slideToIndex(this.props.currentSlide + 1);
  }

  render () {
      if(this.props.quizz){
        return (
          <div className="quizz" >
            <h2 className="quizz__title">Quizz</h2>
            <div className="quizz__main-background" style={{'backgroundImage': 'url('+this.props.quizz.main_background+')'}} ></div>
            <ImageGallery
              ref={i => this._quizzSlides = i}
              items={this.props.quizz.questions}
              autoPlay={false}
              showThumbnails={false}
              showFullscreenButton={false}
              showPlayButton={false}
              showBullets={this.props.showBullets}
              showNav={false}
              onSlide={this.handleSlideChange.bind(this)}
              renderItem={ function(item){

                var slideContentCSS = (function(){
                    var bg = null;
                    if (item.results && this.props.completed) {
                      return {'backgroundImage': 'url(/media/results/ep'+(this.props.quizzId<10?'0':'')+this.props.quizzId+'_'+this.props.finalScore+'.jpg)'};
                    }else{
                      if(item.background){
                        bg = item.background;
                      }else{
                        if(!this.props.quizz.main_background && this.props.quizz.questions[0].background){
                          bg = this.props.quizz.questions[0].background
                        }
                      }

                      return bg ? {'backgroundImage': 'url('+bg+')'} : {};
                    }
                  }.bind(this))();

                if (item.teaser) {

                    return (
                      <div className="quizz__slide-content" >
                        {(() => {
                          if(item.background){
                            return (<img className="quizz__teaser" src={item.background} alt=""/>)
                          }else{
                            return (<div className="quizz__teaser" >{item.teaser}</div>)
                          }
                        })()}
                        <div className="quizz__start-button" onClick={ this.nextSlide.bind(this) } >Débuter le test <span className="arrow"></span></div>
                      </div>
                    )
                }

                if (item.question) {
                  return (
                    <div className="quizz__slide-content"  style={slideContentCSS} >
                      <p className="quizz__question">{item.question}</p>
                      <ul className={ (this.props.answers[this.props.currentSlide]) ? 'quizz__answer-choices answered' : 'quizz__answer-choices' } onClick={ this.handleAnswer.bind(this) }>{
                        item.answers.map( (answer) => {
                          if(answer.value === 2){
                            return (
                              <li key={answer.id} id={answer.id} value={answer.value} className={(()=>'quizz__answer '+(this.props.answers[this.props.currentSlide]===answer.value?'selected':''))()} >
                                {answer.text}
                                <img className="bubble" src={ this.props.quizz.bulle_guide }/>
                              </li>
                            )
                          }else{
                            return(<li key={answer.id} id={answer.id} value={answer.value} className={(()=>'quizz__answer '+(this.props.answers[this.props.currentSlide]===answer.value?'selected':''))()} >{answer.text}</li>)
                          }
                        })
                      }</ul>
                      <div className="quizz__next-button" onClick={ this.nextSlide.bind(this) } >Suivant <span className="arrow"></span></div>
                    </div>
                  )
                }

                if (item.results) {
                  if(this.props.completed) {
                    return (
                      <div className="quizz__slide-content--result" style={slideContentCSS} >
                        {
                          (()=>{
                              if ( this.props.currentScore <= 2){
                                return (<p className="quizz__result" dangerouslySetInnerHTML={{__html: item.results[0]}} ></p>)
                              } else if ( this.props.currentScore > 2 && this.props.currentScore <=4 ){
                                return (<p className="quizz__result" dangerouslySetInnerHTML={{__html: item.results[1]}} ></p>)
                              } else if ( this.props.currentScore > 4 ){
                                return (<p className="quizz__result" dangerouslySetInnerHTML={{__html: item.results[2]}} ></p>)
                              }
                          })()
                        }
                        <div className="quizz__restart-button" onClick={ this.restartQuizz.bind(this) } >Réessayer <span className="arrow"></span></div>
                        <Sharing
                          classes="quizz__sharing"
                          hash="quizz"
                          url={'http://guidesaventure.ca/episode/'+this.props.quizzId+'/score/'+this.props.finalScore}
                          twitterText="Voici mon résultat au test AVENTUROMÈTRE de SUIVEZ LE GUIDE" />
                      </div>
                    )
                  }else{
                    return (
                      <div className="quizz__slide-content--result" style={slideContentCSS} >
                        <p className="quizz__no-result">Vous n&apos;avez pas complété le test.</p>
                      </div>
                    )
                  }
                }
              }.bind(this) }
            />
          </div>
      );
    }else{
      return null;
    }
  }
}

Quizz.propTypes = {
  currentSlide: React.PropTypes.number
};

Quizz.defaultProps = {
  currentSlide: 0
};

const mapStateToProps = function(store, ownProps){
  var completed = false,
    current = 0,
    answers = [],
    finalScore = 0,
    currentScore = 0,
    completed = false;

  if(store.quizz.quizzes && ownProps.quizzId && store.quizz.quizzes[ownProps.quizzId]){
    current = store.quizz.quizzes[ownProps.quizzId].currentSlide || 0;
    answers = store.quizz.quizzes[ownProps.quizzId].answers || {};
    finalScore = store.quizz.quizzes[ownProps.quizzId].finalScore;
    currentScore = store.quizz.quizzes[ownProps.quizzId].currentScore;
    completed = store.quizz.quizzes[ownProps.quizzId].completed;
  }

  return {
    currentSlide: current,
    answers: answers,
    finalScore: finalScore,
    currentScore: currentScore,
    completed: completed,
    showBullets: ((current >= 1)? true : false)
  }
}

export default connect(mapStateToProps)(Quizz);



// WEBPACK FOOTER //
// ./src/components/Quizz.js